import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container block" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "flex flex-ai-c" }
const _hoisted_6 = { class: "align-items" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_popupTeamMember = _resolveComponent("popupTeamMember")!
  const _component_popupEnterprise = _resolveComponent("popupEnterprise")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "请输入人员/派遣单位/项目名称",
          class: "input search-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.searchText]
        ]),
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
        }, "搜索"),
        _createElementVNode("button", {
          class: "btn-white",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args)))
        }, "重置")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn mg-r-10",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/advance/setting')))
        }, "预支配置"),
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isEnterprise = true))
        }, "添加企业")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"},
        "header-row-style": { color: '#202536' },
        "row-style": { color: '#5E617D' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: "300",
            prop: "serveCompanyName",
            label: "企业名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "contacts",
            label: "负责人"
          }),
          _createVNode(_component_el_table_column, {
            prop: "phone",
            label: "手机号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "contacts",
            label: "身份证采集"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_switch, {
                  modelValue: scope.row.isNeedIdcardPhoto,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.isNeedIdcardPhoto) = $event),
                  "active-value": 1,
                  "inactive-value": 0,
                  onChange: ($event: any) => (_ctx.handleSwitchChange(scope.row))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "pwCount",
            label: "审批流设置"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", null, _toDisplayString(scope.row.isNotDefault ? '已设定' : '默认审批流'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "isOpenAdvance",
            label: "预支配置"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_switch, {
                modelValue: scope.row.isOpenAdvance,
                "onUpdate:modelValue": ($event: any) => ((scope.row.isOpenAdvance) = $event),
                "active-value": 1,
                "inactive-value": 0,
                onChange: ($event: any) => (_ctx.handleSwitchChange(scope.row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            width: "150",
            prop: "isShowContacts",
            label: "展示负责人电话"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "mg-r-5" }, "展示负责人电话", -1)),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "关闭后，「子弹工作」将不再展示您的联系方式，他人将无法从该平台联系到你。",
                  placement: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Warning)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx((scope) => [
              _createVNode(_component_el_switch, {
                modelValue: scope.row.isShowContacts,
                "onUpdate:modelValue": ($event: any) => ((scope.row.isShowContacts) = $event),
                "active-value": 1,
                "inactive-value": 0,
                onChange: ($event: any) => (_ctx.handleSwitchChange(scope.row))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            fixed: "right",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  class: "set-btn set-color-success",
                  size: "mini",
                  plain: "",
                  type: "success",
                  onClick: ($event: any) => (_ctx.onIsEditEnterprise(scope.row))
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createElementVNode("span", { class: "icon iconfont icon-bianji" }, null, -1)
                  ])),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "set-btn set-color",
                  size: "mini",
                  plain: "",
                  type: "warning",
                  onClick: ($event: any) => (_ctx.onDeleteCompany(scope.row.id))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Delete)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        class: "pagination",
        currentPage: _ctx.pageNum,
        "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pageNum) = $event)),
        "page-size": _ctx.pageSize,
        "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pageSize) = $event)),
        "page-sizes": [10, 30, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.getList
      }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
    ]),
    (_ctx.isPopupTeamMember)
      ? (_openBlock(), _createBlock(_component_popupTeamMember, {
          key: 0,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isPopupTeamMember = false)),
          selectType: "one",
          onDetermine: _ctx.onAddHead,
          dataTitle: "添加成员"
        }, null, 8, ["onDetermine"]))
      : _createCommentVNode("", true),
    (_ctx.isEnterprise)
      ? (_openBlock(), _createBlock(_component_popupEnterprise, {
          key: 1,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isEnterprise = false)),
          onDetermine: _ctx.onAddEnterprise,
          onSelectHead: _ctx.onSelectHead,
          headList: _ctx.headList,
          dataTitle: "添加企业"
        }, null, 8, ["onDetermine", "onSelectHead", "headList"]))
      : _createCommentVNode("", true),
    (_ctx.isEditEnterprise)
      ? (_openBlock(), _createBlock(_component_popupEnterprise, {
          key: 2,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isEditEnterprise = false)),
          echo: _ctx.currentItem,
          onDetermine: _ctx.onEditEnterprise,
          onSelectHead: _ctx.onSelectHead,
          headList: _ctx.headList,
          dataTitle: "编辑企业"
        }, null, 8, ["echo", "onDetermine", "onSelectHead", "headList"]))
      : _createCommentVNode("", true)
  ]))
}